import {useState, useEffect} from 'react'
import {loadStripe} from '@stripe/stripe-js'
import {ENV} from './_helpers/EnvHelper'

const StripeJSProvider = ({children}: any) => {
  const [stripe, setStripe] = useState<any>(false)
  const PUBLIC_KEY = ENV().REACT_APP_PUBLIC_KEY ?? ''

  useEffect(() => {
    if (!stripe && PUBLIC_KEY && PUBLIC_KEY !== 'pk_test_placeholder') {
      setStripe(loadStripe(PUBLIC_KEY))
    }
  }, [stripe, PUBLIC_KEY])

  return children({stripe})
}

export default StripeJSProvider
